export type WhatsNewFeatureId = 'protect' | 'prepare' | 'history' | 'profiles' | 'export';

export type WhatsNewFeature = {
  id: WhatsNewFeatureId;
  title: string;
  location: string;
  description: string;
  points: string[];
};

export const whatsNewFeatures: WhatsNewFeature[] = [
{
  id: 'protect',
  title: 'Protect surfaces from supports',
  location: 'Tool rail → Protect',
  description:
  'Paint the faces that have to stay clean, like cosmetic sides, gear teeth and mating surfaces. Saved zones never get touchpoints, so there are no nubs to sand off after printing.',
  points: [
  'Brush and eraser with adjustable size, on the original and on every copy',
  '“Protected” blocks supports; “Prefer fewer” only thins them out',
  'AI Select finds cog teeth and protects them in one click']

},
{
  id: 'prepare',
  title: 'Orientation and supports that respect protection',
  location: 'Orient · Supports · 1-Click Print',
  description:
  'Auto-Orient All, Generate Supports and 1-Click Print now read your saved zones. The model is turned so protected areas face away from the platform, and touchpoints are moved to the nearest clean surface around them.',
  points: ['Always applies to the selected model', 'History notes how much protected area stayed support-free']
},
{
  id: 'history',
  title: 'History for each model',
  location: 'Project sidebar → History',
  description: 'Every orient, support, move and protect step is saved with a thumbnail. Select a model or a copy to see its own timeline.',
  points: ['Restore any step or save it as a named version', 'Switch models while the panel stays open']
},
{
  id: 'profiles',
  title: 'Support profiles',
  location: 'Supports → Profiles',
  description: 'Save support settings that work for a type of part and reuse them on similar parts.',
  points: ['Name, icon and quick switching', 'Manage, rename and delete profiles']
},
{
  id: 'export',
  title: 'Export to open formats',
  location: 'Model ⋮ menu → Export Mesh…',
  description: 'Export models as STL, OBJ or 3MF, not only Formlabs’ .form format.',
  points: ['Orientation, scale, units and texture options', 'Duplicate and rename from the same menu']
}];
